// src/components/admin/attendance/HolidayManagement.js
import React from 'react';
import HolidayPlanManagement from './HolidayPlanManagement';

const HolidayManagement = () => {
    return <HolidayPlanManagement />;
};

export default HolidayManagement;
